module.exports = __webpack_public_path__ + "img/users-slash.5f97e4a4.svg";